// extracted by mini-css-extract-plugin
export default {"languageFieldset":"user-email-language-preferences_languageFieldset__Qadb2","radio":"user-email-language-preferences_radio__gv4uC"};